import React from "react";

import OPTComponent from "./opt-component";

import { getLayoutState } from "../../../slices/layouts/reducer";
import { useAppSelector } from "../../../slices/hook";

import { BrandingData } from "admin-portal/settings/branding";
import NoneAuthLayoutSwitch from "../none-auth-layout-switch";

const AdminOTPPage = () => {
  document.title = "Two Steps" + BrandingData.titleSuffix;

  const { layoutNoneAuthTheme } = useAppSelector(getLayoutState);

  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <NoneAuthLayoutSwitch>
        <OPTComponent />
      </NoneAuthLayoutSwitch>
    </React.Fragment>
  );
};

export default AdminOTPPage;
